import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/satisfactions.js';
import q from '../query.js';
export const satisfactionsEntity = `satisfactions`;
const satisfactionsKey = (refId) => `satisfactions-${refId}`;
export const useSatisfactions = (refId) => q.query(satisfactionsKey(refId ?? ''), () => api.get(refId), keys.read.item(satisfactionsEntity, refId ?? ''), { enabled: !!refId });
//# sourceMappingURL=index.js.map